import { render, staticRenderFns } from "./UploaderFile.vue?vue&type=template&id=6b002142"
import script from "./UploaderFile.vue?vue&type=script&lang=js"
export * from "./UploaderFile.vue?vue&type=script&lang=js"
import style0 from "./UploaderFile.vue?vue&type=style&index=0&id=6b002142&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports